// docs: https://github.com/altostra/type-validations#readme
import { objectOf, maybe } from "@altostra/type-validations";
import { boolean, number, string } from "@altostra/type-validations/lib/primitives";

export const isAppsAppIdGetFirebaseCredentialInfoResult = objectOf({
  present: boolean,
  file_bytes: maybe(number),
  updated_at: maybe(string),
  created_at: maybe(string),
  data: maybe(
    objectOf({
      client_id: string,
      project_id: string,
      client_email: string,
      type: string,
    })
  ),
});

export const isAppsAppIdUploadFsaCredentialResult = objectOf({});
